export default __webpack_public_path__ + "static/media/flatout-grey.d6a69a5e.jpg";